module.exports = __webpack_public_path__ + "v4assets/journeys-screenshot.077268aa2f0ebcc8b8957fe3ee9de3f2.png";